import React from "react";
import { useHistory } from "react-router-dom";
import "./CategoryHeader.css";

const CategoryHeader = ({ title }) => {
  const history = useHistory();
  const goBack = () => {
    history.goBack();
  };

  return (
    <div className="category-header">
      <div className="arrow brands_header_back" onClick={goBack}></div>
      <span>{title}</span>
    </div>
  );
};

export default CategoryHeader;
